module.exports = __webpack_public_path__ + "img/other_book.eb2f093e.png";